import React, { useState } from 'react';
import './LinkPreview.scss';

export type LinkPreviewProps = {
  link: string;
  data?: string;
  title: string;
};

const LinkPreview: React.FC<LinkPreviewProps> = ({ link, data, title }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy link:', error);
    }
  };

  return (
    <div className="link-preview">
      <a className="link-preview__content" href={link} target="_blank" rel="noopener noreferrer">
        <div className="link-preview__title">
          {title}
        </div>
      </a>
      <button 
        className={`link-preview__copy-btn ${copied ? 'link-preview__copy-btn--copied' : ''}`}
        onClick={handleCopyLink}
        title={copied ? 'Copied!' : 'Copy link'}
        aria-label={copied ? 'Copied!' : 'Copy link'}
      >
        <i className="material-icons">
          {copied ? 'done' : 'content_copy'}
        </i>
      </button>
    </div>
  );
};

export default LinkPreview;
